/**
 * ALLIN Recently Viewed Products Component
 * Custom web component for displaying recently viewed products with ALLIN styling
 */

class AllinRecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.name = "area_recently_viewed";

    this.recordRecentlyViewed();
    this.loadProducts();
  }

  config() {
    return {
      howManyToStoreInMemory: Number(this.getAttribute('data-count')) + 1,
      settings: this.getAttribute('data-settings')
    };
  }

  setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) {
        var arr = c.substring(nameEQ.length, c.length);
        return arr.split(' ');
      }
    }
    return [];
  }

  recordRecentlyViewed() {
    var config = this.config(),
      recentlyViewed = this.getCookie(this.name);

    if (window.location.pathname.indexOf('/products/') !== -1) {
      var productHandleEl = document.querySelector('[data-product-handle]');
      if (!productHandleEl) return;

      var productHandle = productHandleEl.getAttribute('data-product-handle'),
        position = -1;

      if (recentlyViewed) {
        position = recentlyViewed.indexOf(productHandle);
      }
      if (position === -1) {
        recentlyViewed.unshift(productHandle);
        recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
      } else {
        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }
      this.setCookie(this.name, recentlyViewed.join(' '), 1);
    }
  }

  loadProducts() {
    var currentproducts = this.getCookie(this.name);
    if (currentproducts.length <= 1) return;

    if (window.location.pathname.indexOf('/products/') !== -1) {
      var productHandleEl = document.querySelector('[data-product-handle]');
      if (productHandleEl) {
        var productHandle = productHandleEl.getAttribute('data-product-handle'),
          index = currentproducts.indexOf(productHandle);
        if (index !== -1) currentproducts.splice(index, 1);
      }
    }

    currentproducts = currentproducts.join('||');
    this.getProducts(currentproducts);
  }

  getProducts(currentproducts) {
    var _this = this;
    // Use the ALLIN specific view template
    fetch(`${window.shopUrl}/collections/all?view=allin_recently_viewed&sort_by=${currentproducts}||${this.config().settings}`)
      .then((response) => response.text())
      .then((responseText) => {
        _this.classList.remove("hide");

        // Find the content container and append products
        var contentContainer = _this.querySelector('.featured-collection__container');
        if (contentContainer) {
          contentContainer.innerHTML = responseText;
        } else {
          // Fallback: append after heading
          var heading = _this.querySelector('.content-heading');
          if (heading) {
            heading.insertAdjacentHTML('afterend', responseText);
          } else {
            _this.innerHTML += responseText;
          }
        }

        // Initialize slider after products are loaded
        _this.initSlider();
      })
      .catch((error) => {
        console.error('ALLIN Recently Viewed: Error loading products', error);
      });
  }

  initSlider() {
    const slider = this.querySelector('.slider--phone');
    const buttonsContainer = this.querySelector('.slider__buttons__container');
    const buttonsWrapper = this.querySelector('.slider__buttons');

    if (!slider || !buttonsContainer) return;

    const buttons = buttonsContainer.querySelectorAll('.slider__button');
    if (buttons.length === 0) return;

    // Show buttons container
    if (buttonsWrapper && buttons.length > 1) {
      buttonsWrapper.style.display = 'flex';
    }

    // Update active dot based on scroll position
    const updateActiveDot = () => {
      const scrollLeft = slider.scrollLeft;
      const sliderWidth = slider.offsetWidth;
      const maxScroll = slider.scrollWidth - sliderWidth;

      if (maxScroll <= 0) return;

      const scrollPercentage = (scrollLeft / maxScroll) * 100;
      const activeIndex = Math.round((scrollPercentage / 100) * (buttons.length - 1));

      buttons.forEach((btn, index) => {
        btn.classList.toggle('slider__button--current', index === activeIndex);
      });
    };

    // Scroll to slide when dot is clicked
    buttons.forEach((button, index) => {
      button.addEventListener('click', function() {
        const maxScroll = slider.scrollWidth - slider.offsetWidth;
        const slidePosition = maxScroll * (index / (buttons.length - 1));
        slider.scrollTo({
          left: slidePosition,
          behavior: 'smooth'
        });
      });
    });

    // Update dots on scroll
    let scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveDot, 50);
    });

    // Touch event handling for better mobile experience
    let startX = 0;
    let scrollStart = 0;

    slider.addEventListener('touchstart', function(e) {
      startX = e.touches[0].pageX;
      scrollStart = slider.scrollLeft;
    }, { passive: true });

    slider.addEventListener('touchmove', function(e) {
      const x = e.touches[0].pageX;
      const walk = (startX - x) * 1.5;
      slider.scrollLeft = scrollStart + walk;
    }, { passive: true });
  }
}

// Register the custom element
customElements.define('allin-recently-viewed-products', AllinRecentlyViewedProducts);
